var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.06 2.25a1.5 1.5 0 0 1 1.061.439l4.19 4.187a1.5 1.5 0 0 1 0 2.12L9.75 20.562A1.5 1.5 0 0 1 8.69 21H4.5A1.5 1.5 0 0 1 3 19.5v-4.227a1.5 1.5 0 0 1 .439-1.022L15.001 2.688a1.5 1.5 0 0 1 1.06-.44ZM8.69 19.5 20.25 7.936 16.06 3.75 4.5 15.31v4.19z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.22 5.47a.75.75 0 0 1 1.06 0l5.25 5.25a.75.75 0 0 1-1.06 1.06l-5.25-5.25a.75.75 0 0 1 0-1.06"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.845 8.095a.75.75 0 0 1 1.06 1.06l-9 9a.75.75 0 1 1-1.06-1.06z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.267 14.517a.75.75 0 0 1 1.061 0l5.154 5.155a.75.75 0 1 1-1.06 1.06l-5.155-5.154a.75.75 0 0 1 0-1.06Z"
  })));
};
export default SvgEdit;